import cookies from "js-cookie";
import storageManifest from "../../../../storageManifest.json";
import { storageCanBeSet } from "@JohnLewisPartnership/pecr-util";

export const postcodeCookie = "deliveryCheckerLocation";

export const getCookiePostcode = () => {
  if (typeof window !== "undefined") {
    const encodedPostcode = cookies.get(postcodeCookie);
    try {
      if (encodedPostcode) {
        return window.atob(encodedPostcode);
      }
    } catch (err) {
      return null;
    }
  }
  return null;
};

export const setCookiePostcode = (postcodeField: string) => {
  if (storageCanBeSet(storageManifest.cookie[postcodeCookie])) {
    cookies.set(postcodeCookie, window.btoa(postcodeField.toUpperCase()), {
      path: "/",
      expires: 30,
      secure: true,
    });
  }
};
